<!-- 
    欠费设置组件
    接受：预付费额度、透支比例、账单结算日
 -->
<template>
    <div style="width:60%;margin:0 auto;">
        <el-form :model="arrearageForm" label-width="100px" class="ruleForm">
            <div class="container-title" style="margin-top:0;">预付费业主</div>
            <el-form-item label="透支额度" prop="credit_line">
                <el-input style="width:200px;" v-model="arrearageForm.credit_line"></el-input>&nbsp;&nbsp;元
                <!-- <el-checkbox style="margin-left:20px;" v-model="checked">不限额度</el-checkbox>
                <el-tooltip class="item" effect="dark" content="选中不限额度后表计不会自动停用" placement="top">
                    <i style="vertical-align: top;margin-left:10px;" class="el-icon-info"></i>
                </el-tooltip> -->
            </el-form-item>
            <div style="overflow: hidden;"></div>
            <div class="container-title">后付费业主</div>
            <el-form-item label="透支比例" prop="credit_percent">
                <el-input style="width:200px;" v-model="arrearageForm.credit_percent"></el-input>&nbsp;&nbsp;%
            </el-form-item>
            <div style="overflow: hidden;"></div>
            <div class="container-title">账单结算日</div>
            <el-form-item label="结算日" prop="account_day">
                <el-input style="width:200px;" v-model.number="arrearageForm.account_day"></el-input>&nbsp;&nbsp;日
            </el-form-item>
        </el-form>
        <div style="text-align:center;">
            <el-button type="primary" style="width:150px;" @click="onSave">保存</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cmparrearage',
    props: ['form'],
    data () {
        return {
            arrearageForm:{
                is_pre_pay: 2,  //  是否预付费（0默认，1是，2不是） 默认后付费
                credit_line: 0,  //  预付费额度
                credit_percent: 0,  //  后付费百分比
                account_day: 0,  //  结算日
            },
            checked: false,
        };
    },
    created() {
        if(this.form.oid){
            this.initData(this.form);
        }
    },
    watch: {
        form(val){
            this.initData(val);
        }
    },
    methods: {
        // 初始化数据
        initData(data) {
			let account_day = parseInt(data.account_day);
            this.arrearageForm.account_day = account_day === 0 ? 0 : account_day;
           
        },
        // 保存
        onSave() {
            this.$emit('onSave', this.arrearageForm)
        }
    },

}

</script>
<style lang='less' scoped>

</style>